import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement(React.Fragment, null,
    React.createElement("path", { d: "m9.65 10.952 4.21-.9-.869 4.242-.748-.748h-1.881v-1.882l-.712-.712z" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm4.434-12.542-10.8 2.307 2.728 2.727v3.054h3.053l2.79 2.789 2.229-10.877z" })));
export default createSvgIcon(iconPath, "Sent");
//# sourceMappingURL=StatusSentIcon.js.map